import React from 'react';
import { Col, Modal, Row, Spinner } from 'react-bootstrap';
import { MdOutlineClose } from "react-icons/md";
import { useDispatch } from 'react-redux';
import { applyTenderApi } from '../../../Redux/Action/InterestedTender';
import { fileBaseUrl, formatTimestamp, getAttachmentName } from '../../../Utils/Helper';
import downloadDocImg from "../../../images/download_doc_img.png";
import userIcon from "../../../images/user_icon.png";

const PreviewTenderDetails = ({ uploadModal, setUploadModal, reviewData, getApplyTenderLoading, showApply }) => {
    const dispatch = useDispatch();

    const handleApplyTender = () => {
        const data = {
            tender_id: uploadModal.tenderId,
        }
        dispatch(applyTenderApi(data))
    }

    return (
        <Modal centered className='doc_type' size='lg' show={uploadModal.show} onHide={setUploadModal}>
            <Modal.Body>
                <div className='add_doc_type'>
                    <div className='head'>
                        <h5>{uploadModal.type}</h5>
                        <MdOutlineClose onClick={setUploadModal} />
                    </div>
                    <div className=''>
                        {
                            reviewData?.technical_documentation?.length > 0 &&
                            <div className='add_assignee_form preview_forms'>
                                <div className='head_list_type mb-1'>
                                    <h6>Technical Feasibility</h6>
                                </div>
                                <div className='attachment_box mb-0'>
                                    <Row className='attachments_wrapper' style={{ margin: "0px" }}>
                                        {reviewData?.technical_documentation && reviewData?.technical_documentation?.map((file) => {
                                            const fileURL = file?.media?.split('/')
                                            const fileformat = fileURL[fileURL.length - 1].split('.')
                                            return (
                                                <Col md={6} key={file.id}>
                                                    <a
                                                        href={`${fileBaseUrl}/${file.media}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <div className='attachment_item'>
                                                            <img src={downloadDocImg} alt='' width={'40px'} />
                                                            <div>
                                                                <h6>{fileURL[fileURL.length - 1]}</h6>
                                                                <span>File Format: {fileformat[fileformat.length - 1]}</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </Col>
                                            )
                                        })}
                                    </Row>
                                </div>
                            </div>
                        }

                        {
                            reviewData?.financial_documentation?.length > 0 &&
                            <div className='add_assignee_form preview_forms'>
                                <div className='head_list_type mb-1'>
                                    <h6>Financial Feasibility</h6>
                                </div>
                                <div className='attachment_box mb-0'>
                                    <Row className='attachments_wrapper' style={{ margin: "0px" }}>
                                        {reviewData?.financial_documentation && reviewData?.financial_documentation?.map((file) => {
                                            const fileURL = file?.media?.split('/')
                                            const fileformat = fileURL[fileURL.length - 1].split('.')
                                            return (
                                                <Col md={6} key={file.id}>
                                                    <a
                                                        href={`${fileBaseUrl}/${file.media}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <div className='attachment_item'>
                                                            <img src={downloadDocImg} alt='' width={'40px'} />
                                                            <div>
                                                                <h6>{fileURL[fileURL.length - 1]}</h6>
                                                                <span>File Format: {fileformat[fileformat.length - 1]}</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </Col>
                                            )
                                        })}
                                    </Row>
                                </div>
                            </div>
                        }

                        {
                            reviewData?.tax_documentation?.length > 0 &&
                            <div className='add_assignee_form preview_forms'>
                                <div className='head_list_type mb-1'>
                                    <h6>Tax Certificate</h6>
                                </div>

                                <div className='attachment_box mb-0'>
                                    <Row className='attachments_wrapper' style={{ margin: "0px" }}>
                                        {reviewData?.tax_documentation && reviewData?.tax_documentation?.map((file) => {
                                            const fileURL = file?.media?.split('/')
                                            const fileformat = fileURL[fileURL.length - 1].split('.')
                                            return (
                                                <Col md={6} key={file.id}>
                                                    <a
                                                        href={`${fileBaseUrl}/${file.media}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <div className='attachment_item'>
                                                            <img src={downloadDocImg} alt='' width={'40px'} />
                                                            <div>
                                                                <h6>{fileURL[fileURL.length - 1]}</h6>
                                                                <span>File Format: {fileformat[fileformat.length - 1]}</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </Col>
                                            )
                                        })}
                                    </Row>
                                </div>
                            </div>
                        }

                        {
                            reviewData?.other_documentation?.length > 0 &&
                            <div className='add_assignee_form preview_forms'>
                                <div className='head_list_type mb-1'>
                                    <h6>Other</h6>
                                </div>

                                <div className='attachment_box mb-0'>
                                    <Row className='attachments_wrapper' style={{ margin: "0px" }}>
                                        {reviewData?.other_documentation && reviewData?.other_documentation?.map((file) => {
                                            const fileURL = file?.media?.split('/')
                                            const fileformat = fileURL[fileURL.length - 1].split('.')
                                            return (
                                                <Col md={6} key={file.id}>
                                                    <a
                                                        href={`${fileBaseUrl}/${file.media}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <div className='attachment_item'>
                                                            <img src={downloadDocImg} alt='' width={'40px'} />
                                                            <div>
                                                                <h6>{fileURL[fileURL.length - 1]}</h6>
                                                                <span>File Format: {fileformat[fileformat.length - 1]}</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </Col>
                                            )
                                        })}
                                    </Row>
                                </div>
                            </div>
                        }

                        <div className='all_comments_box mt-5'>
                            <h5>Comments</h5>

                            <div className='all_comments_wrapper'>
                                {reviewData?.comments?.length > 0 && reviewData?.comments.map(c => (
                                    <div key={c.id} className='comment_item list'>
                                        <div className='commenter_detail'>
                                            <img src={c?.user?.image ? `${fileBaseUrl}/${c?.user?.image}` : userIcon} alt="" />
                                            <p>{c?.user?.user_name} - <b>{getAttachmentName(c?.source_type)}</b></p>
                                        </div>

                                        <h6>{c?.comment}</h6>

                                        <div>
                                            <span>{formatTimestamp(c?.created_at)}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {reviewData?.comments?.length === 0 && <p className='text-center'>No comments Yet</p>}
                        </div>

                        {
                            showApply ?
                                <div className='add_assignee_btn p-5'>
                                    <button type="button" onClick={setUploadModal}>Cancel</button>
                                    <button type="button" onClick={handleApplyTender}>
                                        {getApplyTenderLoading ? <Spinner animation='border' size='sm' /> : "Apply"}
                                    </button>
                                </div> :
                                <div className='p-5'></div>
                        }
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PreviewTenderDetails;